import * as React from 'react';
import * as styles from './PeopleFinder.css';
import { PeopleFinderStore, DisplayedPeopleType } from './stores/PeopleFinderStore';
import { observer, inject } from 'mobx-react';
import { PeopleFinderSearch } from './search/PeopleFinderSearch';
import { IAMultiSelectDropDown } from '../multiSelectDropDown/MultiSelectDropDown';
import { PeopleFinderPanel } from './panel/PeopleFinderPanel';
import { Environment } from '../../services/Environment';
import { PeopleFinderCard } from './card/PeopleFinderCard';
import { PeopleFinderHeader } from './header/PeopleFinderHeader';
import { ConditionalOutput } from '../../services/ConditionalOutput';
import { Helper } from '../../Helper';
import { IAIcon } from '../icon/Icon';
import { LocalizationService } from '../../services/LocalizationService';
export interface IPeopleFinderProps {
  peopleFinderStore?: PeopleFinderStore;
  onClose?: () => void;
}

@inject('peopleFinderStore')
@observer
export class PeopleFinder extends React.Component<IPeopleFinderProps, { isHover: boolean }> {
  private ref = React.createRef<HTMLDivElement>();
  // private transformRef = React.createRef<HTMLDivElement>();
  public constructor(props) {
    super(props);
    this.state = {
      isHover: false,
    };
  }

  public componentDidMount() {
    this.props.peopleFinderStore.resize(this.ref.current.clientWidth);
    window.addEventListener('resize', () => this.props.peopleFinderStore.resize(this.ref.current.clientWidth));
    this.props.peopleFinderStore.isFetchingSuggestedPeople = true;
    this.props.peopleFinderStore.getProfileData().then(() => this.props.peopleFinderStore.getSuggestedPeople());
    this.props.peopleFinderStore.getFilterLists();
  }

  private getContentTitle = () => {
    const departments = this.props.peopleFinderStore.filter?.departments;
    const jobTitles = this.props.peopleFinderStore.filter?.jobTitles;
    const isDisplayTypeSearch = this.props.peopleFinderStore.displayedCardType === DisplayedPeopleType.SEARCED;
    const isDisplayTypeSuggested = this.props.peopleFinderStore.displayedCardType === DisplayedPeopleType.SUGGESTED;
    const isFilterSelected = departments?.filter((v) => v.selected).length > 0 || jobTitles?.filter((v) => v.selected).length > 0;
    const isSearchAndFilterEmpty = !!this.props.peopleFinderStore.searchValue || isFilterSelected;
    const title = new ConditionalOutput(new LocalizationService().strings.PeopleFinder_Results).OnCondition(isDisplayTypeSearch && isSearchAndFilterEmpty, `Result of <b>${this.props.peopleFinderStore.searchValue}</b>`).Last();
    return (
      <div className={styles.IA_peopleFinder_body_suggestedPeopleTitleCloseWrapper}>
        {isDisplayTypeSearch && (
          <React.Fragment>
            <div className={styles.IA_peopleFinder_body_suggestedPeopleTitle} dangerouslySetInnerHTML={{ __html: title }} />
            <div
              className={styles.IA_peopleFinder_body_suggestedPeopleCloseButton}
              onClick={() => {
                this.props.peopleFinderStore.displayedCardType = DisplayedPeopleType.SUGGESTED;
                this.props.peopleFinderStore.people = this.props.peopleFinderStore.suggestedPeople;
                this.props.peopleFinderStore.showMore = false;
                this.props.peopleFinderStore.searchValue = '';
              }}
            >
              <IAIcon title="Close" size={18} color={this.props.peopleFinderStore.design.colors.iconColor} style={{ margin: 'auto 0px auto 5px' }} />
            </div>
          </React.Fragment>
        )}
        {isDisplayTypeSuggested && <div className={styles.IA_peopleFinder_body_suggestedPeopleTitle}> {new LocalizationService().strings.PeopleFinder_Suggested} </div>}
      </div>
    );
  }

  private searchedPeople = () => {
    const emptyArray = new Array(this.props.peopleFinderStore.cardsAmount);
    const cardsWrapperWidth = this.ref.current?.clientWidth;
    const startSlice = new ConditionalOutput(0)
      .OnCondition(this.props.peopleFinderStore.pagingIndex > 0, this.props.peopleFinderStore.cardsAmount * this.props.peopleFinderStore.pagingIndex)
      .Last();
    const endSlice = (this.props.peopleFinderStore.cardsAmount * this.props.peopleFinderStore.pagingIndex) + this.props.peopleFinderStore.cardsAmount;
    const people = this.props.peopleFinderStore.people.slice(
      startSlice,
      endSlice
    );
    const calc = this.props.peopleFinderStore.people?.length / (this.props.peopleFinderStore.cardsAmount + 1);
    const pagesAmount = new ConditionalOutput(Math.round(calc))
      .OnCondition(Math.round(this.props.peopleFinderStore.people?.length % (this.props.peopleFinderStore.cardsAmount + 1)) !== 0, Math.round(calc) + 1)
      .Last();
    return (
      <React.Fragment>
        <div className={styles.IA_peopleFinder_body_searchedPeopleWrapper}>
          <div className={styles.IA_peopleFinder_body_contentPagingEffectWrapper}
            style={{ width: cardsWrapperWidth + 2 }}
          >
            <div className={styles.IA_peopleFinder_body_contentPagingEffect}
              style={{
                width: `calc(${cardsWrapperWidth}px * ${pagesAmount})`,
                // height: this.ref.current?.clientHeight,
                transform: `translateX(-${cardsWrapperWidth * (this.props.peopleFinderStore.pagingIndex)}px)`,
              }}
            >
              {[...new Array(pagesAmount)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    width: this.ref.current?.clientWidth,
                  }}
                  className={styles.IA_peopleFinder_body_searchedPeopleContentWrapper}
                  onMouseOver={() => this.setState({ isHover: true })}
                  onMouseLeave={() => this.setState({ isHover: false })}
                >
                  {this.props.peopleFinderStore.isFetchingSearchResults &&
                    emptyArray.map((_, index) => {
                      return (
                        <PeopleFinderCard
                          key={index}
                          design={{
                            colors: {
                              iconColor: this.props.peopleFinderStore.design.colors.iconColor,
                              highlightTextColor: this.props.peopleFinderStore.design.colors.highlightTextColor,
                              mainColor: this.props.peopleFinderStore.design.colors.mainColor,
                              highlightColor: undefined,
                            },
                          }}
                          showSkeleton={true}
                        />
                      );
                    })}
                  {people?.map((person, index) => {
                    return (
                      <PeopleFinderCard
                        key={index}
                        properties={{
                          ...person,
                          photo: Helper.getProfileImageUrlFromImageAPI(
                            Environment.getEnvironmentForImageAPI(this.props.peopleFinderStore.environment),
                            this.props.peopleFinderStore.tenantName,
                            this.props.peopleFinderStore.token,
                            person?.email
                          ),
                        }}
                        index={startSlice + index}
                        design={{
                          colors: {
                            iconColor: this.props.peopleFinderStore.design.colors.iconColor,
                            highlightTextColor: this.props.peopleFinderStore.design.colors.highlightTextColor,
                            mainColor: this.props.peopleFinderStore.design.colors.mainColor,
                            highlightColor: undefined,
                          },
                        }}
                        onClick={(_) => {
                          this.props.peopleFinderStore.openPanel(person);
                        }}
                        isHighlighted={person.id === this.props.peopleFinderStore.selectedPerson?.id}
                      />
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
          {this.props.peopleFinderStore.showPaging && (
            <div
              className={styles.IA_peopleFinder_body_content_paging}
              style={{
                opacity: this.state.isHover ? 1 : 0,
                height: this.ref.current?.clientHeight,
                width: this.ref.current?.clientWidth,
              }}
              onClick={(e) => e.stopPropagation()}
              onMouseOver={() => this.setState({ isHover: true })}
              onMouseLeave={() => this.setState({ isHover: false })}
            >
              <div>
                {this.props.peopleFinderStore.showLeftPaging && (
                  <div className={styles.IA_peopleFinder_body_content_paging_left} onClick={() => this.props.peopleFinderStore.prevPage()}>
                    <div>
                      <IAIcon url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Left/SVG/ic_fluent_chevron_left_48_regular.svg" color={'#fff'} size={30} />
                    </div>
                  </div>
                )}
              </div>
              <div>
                {this.props.peopleFinderStore.showRightPaging && (
                  <div className={styles.IA_peopleFinder_body_content_paging_right} onClick={() => this.props.peopleFinderStore.nextPage()}>
                    <div>
                      {
                        this.props.peopleFinderStore.isFetchingNextPage &&
                        <div >
                          <div
                            className={styles.IA_peopleFinder_searchInputListCardSpinner}
                            style={{
                              padding: 0,
                            }}
                          >
                            <IAIcon title="Spinner" size={20} color={'#fff'} />
                          </div>
                        </div>
                      }
                      {
                        !this.props.peopleFinderStore.isFetchingNextPage &&
                        <IAIcon title={'Arrow'} color={'#fff'} size={30} />
                      }
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }

  public render() {
    return (
      <div className={styles.IA_peopleFinder_wrapper}>
        <PeopleFinderHeader Close={this.props.onClose} />
        <div className={styles.IA_peopleFinder_body}>
          <PeopleFinderSearch />
          <div
            className={styles.IA_peopleFinder_body_filterWrapper}
            style={{
              height: this.props.peopleFinderStore.showFilter ? 200 : 0,
            }}
          >
            <div className={styles.IA_peopleFinder_body_filterComponentWrapper}>
              <div className={styles.IA_peopleFinder_body_filterComponent}>
                {this.props.peopleFinderStore.filter?.jobTitles && (
                  <div>
                    <IAMultiSelectDropDown
                      placeholder={new LocalizationService().strings.PeopleFinder_JobTitleLabel}
                      options={this.props.peopleFinderStore.filter?.jobTitles}
                      styles={{ width: 210 }}
                      themeColor={this.props.peopleFinderStore.design.colors.mainColor}
                      onSelectOptions={(jobTitles) => {
                        this.props.peopleFinderStore.toggleFilter('jobTitles', jobTitles);
                        if (this.props.peopleFinderStore.filter.jobTitles.filter((d) => d.selected).length > 0) {
                          this.props.peopleFinderStore.displayedCardType = DisplayedPeopleType.SEARCED;
                        }
                        this.props.peopleFinderStore.getSearched();
                      }}
                    />
                  </div>
                )}
              </div>
              <div className={styles.IA_peopleFinder_body_filterComponent}>
                {this.props.peopleFinderStore.filter?.departments && (
                  <div>
                    <IAMultiSelectDropDown
                      placeholder={new LocalizationService().strings.PeopleFinder_Department}
                      options={this.props.peopleFinderStore.filter?.departments}
                      styles={{ width: 210 }}
                      themeColor={this.props.peopleFinderStore.design.colors.mainColor}
                      onSelectOptions={(departments) => {
                        this.props.peopleFinderStore.toggleFilter('departments', departments);
                        if (this.props.peopleFinderStore.filter.departments.filter((d) => d.selected).length > 0) {
                          this.props.peopleFinderStore.displayedCardType = DisplayedPeopleType.SEARCED;
                        }
                        this.props.peopleFinderStore.getSearched();
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.IA_peopleFinder_body_content} ref={this.ref}>
            {this.getContentTitle()}
            {this.props.peopleFinderStore.displayedCardType === DisplayedPeopleType.SUGGESTED && <React.Fragment>
              <div className={styles.IA_peopleFinder_body_suggestedPeopleWrapper}>
                <div className={styles.IA_peopleFinder_body_suggestedPeopleContentWrapper}>
                  {this.props.peopleFinderStore.isFetchingSuggestedPeople &&
                    [...new Array(5)].map((_, index) => {
                      return (
                        <PeopleFinderCard
                          key={index}
                          design={{
                            colors: {
                              iconColor: this.props.peopleFinderStore.design.colors.iconColor,
                              highlightTextColor: this.props.peopleFinderStore.design.colors.highlightTextColor,
                              mainColor: this.props.peopleFinderStore.design.colors.mainColor,
                              highlightColor: undefined,
                            },
                          }}
                          showSkeleton={true}
                        />
                      );
                    })}
                  {this.props.peopleFinderStore.people?.map((person, index) => {
                    return (
                      <PeopleFinderCard
                        key={index}
                        properties={{
                          ...person,
                          photo: Helper.getProfileImageUrlFromImageAPI(
                            Environment.getEnvironmentForImageAPI(this.props.peopleFinderStore.environment),
                            this.props.peopleFinderStore.tenantName,
                            this.props.peopleFinderStore.token,
                            person?.email
                          ),
                        }}
                        index={index}
                        design={{
                          colors: {
                            iconColor: this.props.peopleFinderStore.design.colors.iconColor,
                            highlightTextColor: this.props.peopleFinderStore.design.colors.highlightTextColor,
                            mainColor: this.props.peopleFinderStore.design.colors.mainColor,
                            highlightColor: undefined,
                          },
                        }}
                        onClick={(_) => {
                          this.props.peopleFinderStore.openPanel(person);
                        }}
                        isHighlighted={person.id === this.props.peopleFinderStore.selectedPerson?.id}
                      />
                    );
                  })}
                </div>
              </div>
            </React.Fragment>}
            {this.props.peopleFinderStore.displayedCardType === DisplayedPeopleType.SEARCED && this.searchedPeople()}
          </div>
        </div>
        <PeopleFinderPanel
          design={this.props.peopleFinderStore.design}
          isPanelOpen={this.props.peopleFinderStore.isPanelOpen}
          coverImage={'https://www.incimages.com/uploaded_files/image/1920x1080/getty_509107562_2000133320009280346_351827.jpg'} // TODO CHANGE TO DESIRED IMAGE
          person={this.props.peopleFinderStore.selectedPerson}
        />
      </div>
    );
  }
}
